import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

export const facultySchema = z.object({
  name: z.string().min(3),
  headOfFaculty: identitySchema,
  teachersNo: z.number(),
  domain: z.enum(['MEDICAL', 'RESEARCH', 'TECH']),
});

export const defaultFacultyValues: DefaultValues<FacultySchema> = {
  name: '',
};

export type FacultySchema = z.infer<typeof facultySchema>;
